import { render } from "./ProIndex.vue?vue&type=template&id=2815f644"
import script from "./ProIndex.vue?vue&type=script&lang=js"
export * from "./ProIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__